<template>
  <div class="main_right access-ctrl-device-center">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="account">
      <div class="school">
        <el-input placeholder="名称" v-model="filterText"
                  class="margin-bottom-4" size="small" />
        <the-tree title="门禁组织" keyName="门禁组织名称" class="filter-tree"
                  :filterKey="filterText" :update="treeUpdate" :maxDepth="4"
                  @selected="handleSelected" :options="treeOptions"
        />
      </div>

      <div class="content access_ctrl">
        <!-- region 顶部操作栏 -->
        <div class="top-bar">
          <div>
            <p class="statues">
              设备状态
              <el-select v-model="requestBody.deviceStatus" placeholder="全部"
                         size="small" @change="handleSelect" style="width: 100px;">
                <el-option v-for="item in deviceOptions" :key="item.id"
                           :label="item.label" :value="item.id">
                </el-option>
              </el-select>
            </p>
            <p class="statues">
              应用场景
              <el-select v-model="requestBody.scence" placeholder="全部"
                         size="small" @change="scenceSelect" style="width: 100px;">
                <el-option v-for="item in scenceList" :key="item.code"
                           :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </p>
            <p class="statues">
              设备类型
              <el-select v-model="requestBody.deviceType" placeholder="全部"
                         size="small" @change="deviceTypeSelect" style="width: 180px;">
                <el-option v-for="item in deviceTypeOptions" :key="item.id"
                           :label="item.label" :value="item.id">
                </el-option>
              </el-select>
            </p>
          </div>
          <input-search class="search" @search="search" placeholder="设备名称/编号" />
        </div>
        <div class="top-bar">
          <div class="left">
            <button-add @click="handleAdd()" />
            <button-delete @click="remove(selected)" />
            <button-other @click="onSync()"/>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <button-upload
              :cathUrl="uploadUrl"
              :onSuccess="onUploadSuccess"
              value="导入"/>
            <button-export
              :href="exportUrl"
              :beforeDownload="beforeDownload"
              download="download.xls"
              value="导出"/>
          </div>
        </div>
        <!-- endregion 顶部操作栏 -->
        <!-- region 表格 -->
        <el-table class="width-full" :data="posDevices" :height="618"
                  header-row-class-name="app-center-table-header"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" />
          <el-table-column label="设备名称">
            <template slot-scope="scope">
              <div :title="scope.row.deviceName">{{scope.row.deviceName}}</div>
            </template>
          </el-table-column>
          <el-table-column label="设备编号">
            <template slot-scope="scope">
              <span :title="scope.row.deviceCode">{{scope.row.deviceCode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备类型" width="120">
            <template slot-scope="scope">
              <span :title="scope.row.deviceTypeName">{{scope.row.deviceTypeName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备型号" width="120">
            <template slot-scope="scope">
              <span :title="scope.row.deviceModelName">{{scope.row.deviceModelName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="应用场景" width="80">
            <template slot-scope="scope">
              <span :title="scope.row.scenceName">{{scope.row.scenceName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="进出类型" width="80">
            <template slot-scope="scope">
              <span :title="scope.row.passTypeText">{{scope.row.passTypeText}}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属住户" width="80">
            <template slot-scope="scope">
              <span :title="scope.row.enterpriseName">{{scope.row.enterpriseName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备状态" width="80">
            <template slot-scope="scope">
              <div style="background-color: #F56C6C;width: 15px;height: 15px;border-radius: 50%;margin: 0 auto;" v-if="scope.row.deviceStatus === '0'"></div>
              <div style="background-color: #67C23A;width: 15px;height: 15px;border-radius: 50%;margin: 0 auto;" v-else-if="scope.row.deviceStatus === '1'"></div>
            </template>
          </el-table-column>
          <el-table-column label="设备位置" width="80">
            <template slot-scope="scope">
              <span :title="scope.row.location">{{scope.row.location}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <a @click="synchronization(scope.row)" v-if="scope.row.deviceManufacturerCode === '100061'">同步人脸</a>
              <a @click="getDevicePersonCount(scope.row.deviceCode, scope.row.deviceStatus, scope.row.deviceManufacturerCode)" v-if="scope.row.deviceManufacturerCode !== '大麦物联'">人数</a>
              <a @click="showDetail(scope.row.deviceCode)">查看</a>
              <a @click="remove(scope.row.deviceCode)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <!-- endregion 表格 -->
        <div class="page">
          <el-pagination background layout="total, prev, pager, next, jumper"
                         @current-change="onPageChanged" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      title="同步人脸"
      :visible.sync="synchronizationDialogVisible"
      width="500px">
      <el-button type="primary" @click="syncPersonPicToDevice" style="margin-right: 20px;">增量同步</el-button>
      <el-button type="primary" @click="clearAllFace">清空后同步</el-button>
    </el-dialog>
  </div>
</template>

<script>
import {api, newApi} from '../../api/access-ctrl'
import TheTree from '../../../components/common/the-tree'
import {nAlert, nSuccess, nTipFunc, nWarn} from '../../../utils/notice'
import InputSearch from '../../../components/common/inputs/input-search'
import ButtonAdd from '../../../components/common/buttons/button-add'
import ButtonDelete from '../../../components/common/buttons/button-delete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
// import ButtonOther from "../../../components/common/buttons/button-other";
import {commonConfig} from '../common'
import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
import {errorHandler} from '../../../utils/errorHandler'
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import STree from '../../../components/common/s-tree'
import {treeApi} from '../../api/TreeApi'

export default {
  name: 'access-ctrl-device-management-center',
  components: {
    STree,
    Breadcrumb,
    BreadCrumb,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    InputSearch,
    TheTree,
    // ButtonOther
  },
  data () {
    return {
      deviceOptions: [{
        id: '',
        label: '全部'
      }, {
        id: '0',
        label: '离线'
      }, {
        id: '1',
        label: '在线'
      }],
      deviceTypeOptions: [{
        id: '',
        label: '全部'
      }, {
        id: '1',
        label: '二维码云门禁一体机'
      }, {
        id: '2',
        label: '二维码签到终端'
      }, {
        id: '3',
        label: '人脸识别终端'
      }, {
        id: '4',
        label: '人脸签到终端'
      }, {
        id: '5',
        label: '二维码云门禁控制器'
      }, {
        id: '6',
        label: '二维码核身终端'
      }],

      scenceList: [
        {code: '', name: '全部'},
        {code: '1', name: '公共场景'},
        {code: '2', name: '住户场景'},
        {code: '4', name: '预约场景'},
        {code: '3', name: '其他场景'},
        {code: '5', name: '看房场景'}
      ],
      treeOptions: {
        1: ['add'],
        2: ['add', 'patch', 'delete'],
        3: ['add', 'patch', 'delete'],
        4: ['patch', 'delete']
      },
      config: {
        breadcrumb: [{
          value: '智慧门禁',
          name: 'accessCtrlDeviceManagementCenter'
        }, {
          value: '设备管理',
        }],
      },
      // region 更新树的方法
      treeUpdate: {
        render: (code) => {
          return api.getOrganizationTreeListById(code || 0)
            .then(list => {
              list.forEach(tree => {
                tree._label = tree.name
              })
              return list
            })
        },
        addNode: (node) => {
          node.name = node._label
          return api.addOrganization(node)
        },
        removeNode: (id) => {
          return api.removeOrganization(id + '')
        },
        editNode: (node) => {
          node.name = node._label
          return api.editOrganization(node)
        }
      },
      // endregion 更新树的方法
      exportUrl: api.accessDeviceInfoDownloadUrl(),
      exportOrganizationUrl: api.organizationInfoDownloadUrl(),
      uploadUrl: api.accessDeviceInfoUploadUrl(),
      uploadOrganizationUrl: api.organizationInfoUploadUrl(),
      filterText: '',
      posDevices: [],
      total: 0,
      requestBody: {
        pageNum: '1',
        pageSize: '10',
        searchKey: '',
        organizationCode: '',
        deviceStatus: '',
        deviceType: '',
        scence: ''
      },
      id: '1',
      treeFromServer: [],
      tree: [],
      selected: '',
      enterpriseCode: '',
      enterpriseHasRoomCode: '',
      enterpriseHasRoomNumber: '',
      organizationCode: '',
      organizationName: '',

      synchronizationDialogVisible: false,
      synchronizationDeviceData: ''
    }
  },
  created () {
    this.render()
  },
  watch: {
    '$route' () {
      this.render()
    }
  },
  methods: {
    onSync() {
      // let formData = new FormData();
      // formData.append('deviceType', '1,3,15');
      this.$axios.post(`${newApi.syncDevice}?deviceType=1,3,15`)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('同步成功');
            this.isTree = false;
            setTimeout(() =>{
              this.filterText = '';
              this.$refs.inputSearch.value = '';
              this.requestBody.searchKey = ''
              this.requestBody.pageNum = 1
              this.isTree = true;
              this.render();
            }, 500)
          }
        })
        .catch(err =>{
          nWarn('同步失败')
        })
    },
    beforeDownload () {
      let url = api.accessDeviceInfoDownloadUrl()
      this.exportUrl = `${url}&searchKey=${this.requestBody.searchKey}&organizationCode=${this.requestBody.organizationCode}&deviceStatus=${this.requestBody.deviceStatus}&deviceType=${this.requestBody.deviceType}&scence=${this.requestBody.scence}`
    },
    /**
     * 多选框选择事件
     */
    handleSelectionChange (selectedIds) {
      console.log(selectedIds)
      let deviceCodeArr = []
      selectedIds.map(v => {
        deviceCodeArr.push(v.deviceCode)
      })
      this.selected = deviceCodeArr.join(',')
    },

    /**
     * 移除
     */
    remove (codes) {
      if (codes.length === 0) {
        nWarn('请先选择需要删除的设备')
        return
      }
      this.$confirm('确认删除？')
        .then(
          () => {
            api.deleteAccessDevice({codes: codes})
              .then(nTipFunc('删除成功'))
              .then(this.render)
          },
          () => {
            console.debug('用户取消了删除')
          }
        )
    },

    render () {
      this.renderPosDevices()
    },

    renderPosDevices () {
      api.getAccessDevice(this.requestBody)
        .then(data => {
          // for (let k = 0; k < data.list.length; k++) {
          //   if (data.list[k].deviceStatus === '1') {
          //     data.list[k].deviceStatus = '在线'
          //   } else {
          //     data.list[k].deviceStatus = '离线'
          //   }
          // }
          this.total = data.total
          data.list.map(v => {
            if (v.deviceType === '1') {
              v.deviceTypeName = '二维码云门禁一体机'
            } else if (v.deviceType === '2') {
              v.deviceTypeName = '二维码签到终端'
            } else if (v.deviceType === '3') {
              v.deviceTypeName = '人脸识别终端'
            } else if (v.deviceType === '4') {
              v.deviceTypeName = '人脸签到终端'
            } else if (v.deviceType === '5') {
              v.deviceTypeName = '二维码云门禁控制器'
            } else if (v.deviceType === '6') {
              v.deviceTypeName = '二维码核身终端'
            } else if (v.deviceType === '7') {
              v.deviceTypeName = '人脸闸机网关'
                 console.log('人脸闸机网关');
            } else if (v.deviceType === '14') {
              v.deviceTypeName = '门禁一体机'
            }else {
              v.deviceTypeName = '--'
            }
            this.scenceList.map(scene => {
              if (scene.code === v.scence) {
                v.scenceName = scene.name
              }
            })
            if (v.passType === '1') {
              v.passTypeText = '进'
            } else if (v.passType === '2') {
              v.passTypeText = '出'
            } else if (v.passType === '3') {
              v.passTypeText = '进/出'
            }
          })
          this.posDevices = data.list
        })
    },

    onPageChanged (page) {
      this.requestBody.pageNum = page + ''
      this.renderPosDevices()
    },

    search (val) {
      this.requestBody.pageNum = '1'
      this.requestBody.searchKey = val
      this.renderPosDevices()
    },

    handleSelect (val) {
      this.requestBody.pageNum = '1'
      this.requestBody.deviceStatus = val
      this.renderPosDevices()
    },

    scenceSelect(val) {
      this.requestBody.pageNum = '1'
      this.requestBody.scence = val
      this.renderPosDevices()
    },

    deviceTypeSelect (val) {
      this.requestBody.pageNum = '1'
      this.requestBody.deviceType = val
      this.renderPosDevices()
    },

    handleAdd () {
      if (!this.organizationCode) {
        nAlert('请先选择设备所属组织')
        return
      }
      window.sessionStorage.setItem('organizationCode', this.organizationCode)
      window.sessionStorage.setItem('organizationName', this.organizationName)
      this.$router.push({
        path: '/access-control/device/add'
      })
    },

    handleSelected (node) {
      this.requestBody.pageNum = '1'
      this.organizationCode = node.data.code
      this.organizationName = node.data.name
      this.requestBody.organizationCode = node.data.code
      this.renderPosDevices()
    },

    showDetail (code) {
      this.$router.push({
        path: '/access-control/device/current/' + code
      })
    },

    onUploadSuccess (data) {
      const e = errorHandler('导入失败')(data)
      if (!(e instanceof Error)) {
        nSuccess('导入成功')
        this.render()
      }
    },

    synchronization (data) {
      this.synchronizationDeviceData = data
      this.synchronizationDialogVisible = true
    },

    // 获取人脸数量
    getDevicePersonCount (code, deviceStatus, deviceManufacturerCode) {
      api.getDevicePersonCount({deviceCode: code})
        .then(data => {
          this.$alert(`当前设备人脸数量：${data}`, '设备人脸数量', {
            confirmButtonText: '确定',
            callback: action => {
              console.log(action)
            }
          })
        })
    },

    // 同步人脸
    syncPersonPicToDevice () {
      api.syncPersonPicToDevice(this.synchronizationDeviceData)
        .then(data => {
          nSuccess('操作成功')
          this.synchronizationDialogVisible = false
        })
    },

    // 清空人脸
    clearAllFace () {
      api.clearAllFace(this.synchronizationDeviceData)
        .then(data => {
          this.syncPersonPicToDevice()
        })
    }
  }
}
</script>

<style scoped>
  .account {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
  }

  .school {
    width: 18%;
    float: left;
    padding: 20px 10px 0 0;
    border-right: 1px solid #E6EBF2;
  }

  .yq_name li {
    width: 100px;
  }

  .content {
    width: 81%;
    float: left;
    padding-top: 20px;
    margin-left: 1%;
    position: relative;
  }

  .statues {
    display: inline-block;
    line-height: 32px;
    margin-right: 10px;
  }

  .select-box select {
    width: 60%;
    height: 24px;
    margin-left: 5px;
    border: 1px solid #D7D7D7;
  }

  .info ul {
    height: 42px;
    color: #48576A;
    font-weight: 400;
    background-color: #EFF1F5;
    line-height: 40px;
    margin-top: 5px;
  }

  .page {
    margin: 20px auto;
    /*position: absolute;*/
    /*left: 0;*/
    /*right: 0;*/
    /*bottom: 20px;*/
  }
  .width-full a {
    color: #00a0e6;
  }
  .width-full a:hover {
    color: #06b3ff;
  }
</style>

<style lang="less">
.access-ctrl-device-center {
  .top-bar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    margin: 0 10px 15px 15px;
    .left {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .search {
      width: 240px;
    }
    .export {
      width: 80px;
      height: 30px;
      line-height: 30px;
      color: #FFFFFF;
      border-radius: 5px;
      float: left;
      font-size: 14px;
      color: white;
      margin-right: 2%;
      text-align: center;
      border: 0;
      font-weight: 400;
      color: #48576A;
      border: 1px solid #D7D7D7;
      background-color: #F7F7F7;
      &:hover {
        color: #00A0E6 !important;
        border: 1px solid #00A0E6 !important;
      }
    }
  }
  .el-tree-node.is-current > .el-tree-node__content {
    background-color: #f0f7ff;
  }

  .app-center-table-header th {
    background-color: #EFF1F5 !important;
    color: #48576A;
    .cell {
      text-align: center;
    }
  }
  .el-table {
    position: initial;
  }
  .el-table .cell {
    text-align: center;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/view/AccessCtrl/device-management/center.vue